import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

// Social Layer — global social feed (SOCIAL_LAYER_PLAN §A / P2).
const SocialFeedPage = lazy(() =>
  import('../pages/feed/SocialFeedPage').then((m) => ({ default: m.SocialFeedPage }))
)

export const feedRoutes: RouteObject[] = [
  { path: '/feed', element: <SocialFeedPage authorKind="client" /> },
]
